import { OrderCellProps } from "../OrdersTable.types";

import styles from "../OrdersTable.module.scss";

export const OrderCell = ({ order }: OrderCellProps) => (
  <>
    <div className={styles.ordersTable_orderId}>{order.id}</div>

    <div className={styles.ordersTable_orderAddress}>
      {order.deliveryAddressNeighborhood}, {order.deliveryAddressCity},{" "}
      {order.deliveryAddressCountry}
    </div>
  </>
);
